import React from 'react';
import { useSelector } from 'react-redux';
import Button from '../../button';
import Modal from '../../atoms/modal';
import Text from '../../text';
import { isMobile as isMobileSelector } from '../../../store/modules/header-module';

type Props = {
  onLeave: (...args: Array<any>) => any;
  onStay: (...args: Array<any>) => any;
};

function ExitReverieModal({ onLeave, onStay }: Props) {
  const isMobile = useSelector(isMobileSelector);

  return (
    <Modal title="Find Other Medications" name="leave-reverie" dismissible>
      <Text className="mb-sm-24" type="title3-blinkui" el="p">
        Are you sure you want to go to Blink Health?
      </Text>
      <Text className="mb-sm-12" type="body2-blinkui" el="p">
        You are in BlinkRx. Continue to Blink Health to:
      </Text>
      <ul className="mb-sm-24 mb-md-48 pl-sm-20">
        <Text el="li" type="body2-blinkui" className="mb-sm-12 pl-sm-16">
          Search prices on 15,000+ medications (without insurance)
        </Text>
        <Text el="li" type="body2-blinkui" className="mb-sm-12 pl-sm-16">
          Save up to 80% compared to retail markup
        </Text>
        <Text el="li" type="body2-blinkui" className="mb-sm-12 pl-sm-16">
          Get free shipping or pick up at 35,000 pharmacies nationwide
        </Text>
      </ul>
      <div className="d-sm-flex flex-sm-column flex-md-row mt-sm-48">
        <Button isReverie fullWidth={isMobile} eventName="Went to Blink Health" onClick={onLeave}>
          Continue to Blink Health
        </Button>

        <Button
          isReverie
          className="mt-sm-12 mt-md-0 ml-md-12"
          type="secondary"
          fullWidth={isMobile}
          eventName="Stay in BlinkRx"
          onClick={onStay}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
}

export default ExitReverieModal;
